"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.useData = void 0;
const react_1 = require("react");
const createReducer = () => (state, action) => {
    switch (action.type) {
        case "loading":
            return { data: state.data, loading: true };
        case "result":
            return { data: action.result, loading: false };
        case "error":
            return { loading: false, error: action.error };
    }
};
/**
 * Helper function to fetch data with status and error.
 *
 * @param fetchDataAsync - async function of how to fetch data
 * @param options - if autoLoad is true, reload data immediately
 * @returns data, loading status, error and reload function
 *
 * @beta
 */
function useData(fetchDataAsync, options) {
    var _a;
    const auto = (_a = options === null || options === void 0 ? void 0 : options.autoLoad) !== null && _a !== void 0 ? _a : true;
    const [{ data, loading, error }, dispatch] = (0, react_1.useReducer)(createReducer(), {
        loading: auto,
    });
    function reload() {
        if (!loading)
            dispatch({ type: "loading" });
        fetchDataAsync()
            .then((data) => dispatch({ type: "result", result: data }))
            .catch((error) => dispatch({ type: "error", error }));
    }
    (0, react_1.useEffect)(() => {
        if (auto)
            reload();
    }, []);
    return { data, loading, error, reload };
}
exports.useData = useData;
